interface CleviaLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  textColor?: string;
  label?: string;
}

const sizeConfig = {
  sm: { text: 'text-xl' },
  md: { text: 'text-2xl' },
  lg: { text: 'text-3xl' },
  xl: { text: 'text-4xl' },
};

export function CleviaLogo({
  size = 'md',
  className = '',
  textColor,
  label = 'clevia',
}: CleviaLogoProps) {
  const config = sizeConfig[size];

  return (
    <div className={`flex items-center ${className}`}>
      <span className={`${config.text} font-bold ${textColor || 'text-[#16c47f]'}`}>{label}</span>
    </div>
  );
}
